<template>
  <b-container fluid>
    <b-button class="mb-3" @click="$router.go(-1)" variant="outline-dark">
      <b-icon-arrow-bar-left size="lg"></b-icon-arrow-bar-left>
      Back
    </b-button>
    <b-row>
      <b-col class="text-center">
        <h1 class="text-center text-red-600 bg-blue-600 font-bold">
          {{ $route.params.trackid ? "Edit this" : "Create New" }} Testspace
        </h1>
      </b-col>
    </b-row>
    <b-row>
      <b-modal
        id="modal-leave"
        centered
        title="Confirm Exit"
        ok
        ok-variant="danger"
        cancel-variant="success"
        @ok="leaveRoute"
        @cancel="stayRoute"
      >
        <template v-slot:modal-ok> Leave </template>
        <p>Are You sure you want to leave. You may loose unsaved changes.</p>
      </b-modal>
      <b-col class="m-0 p-0">
        <form @submit.prevent="setTestspace">
          <b-overlay :show="sent || fetching" rounded="sm">
            <b-card bg-variant="light" class="m-0 p-0">
              <b-form-group class="mb-0">
                <div v-if="uploaded" class="alert alert-success p-3">
                  Testspace Created
                </div>
                <b-form-group label="Test Title">
                  <b-form-input
                    v-model="testspace.title"
                    placeholder="Test Title"
                  ></b-form-input>
                </b-form-group>

                <b-form-group
                  v-if="
                    $route.query.module == 'base' ||
                      details.clearance_organization == 'Quicktest'
                  "
                  label="Select Test category"
                  label-for="category"
                >
                  <b-form-select
                    id="category"
                    :options="categoryarr"
                    v-model="testspace.category"
                    @change="chgcategory"
                    required
                  >
                    <b-form-select-option value="null"
                      >--Select category--</b-form-select-option
                    >
                  </b-form-select>
                </b-form-group>

                <b-form-group
                  v-if="testspace.category != null && sameName != 'Yes'"
                  :label="
                    `Select Test ${
                      $route?.query?.domain == 'base' ? 'Institution' : 'Group'
                    }`
                  "
                  label-for="selectinstitution"
                >
                  <b-form-select
                    id="selectinstitution"
                    class="form-inp"
                    :options="institutionsarr"
                    v-model="testspace.test_institution_id"
                    @change="chgInstitution"
                    required
                  >
                    <b-form-select-option value="null"
                      >--Select
                      {{
                        `Test ${
                          $route?.query?.domain == "base"
                            ? "Institution"
                            : "Group"
                        }`
                      }}--</b-form-select-option
                    >
                  </b-form-select>
                </b-form-group>

                <b-form-group
                  class="nested-form-group"
                  v-if="
                    testspace.structure == 'Section' &&
                      testspace.test_institution != null
                  "
                  label="Select Test Level"
                  label-for="institution"
                >
                  <b-form-select
                    v-model="testspace.level"
                    @change="chgcourses"
                    :options="levelarr"
                  >
                    <b-form-select-option value="null"
                      >--Select Level--</b-form-select-option
                    >
                  </b-form-select>
                </b-form-group>

                <b-form-group
                  class="nested-form-group"
                  v-if="
                    testspace.structure == 'Section' &&
                      testspace.test_institution != null &&
                      testspace.level != null
                  "
                  label="Select Test Course"
                  label-for="institution"
                >
                  <b-form-select
                    v-model="testspace.course"
                    @change="chgsection"
                    :options="coursesarr"
                  >
                    <b-form-select-option value="null"
                      >--Select Course--</b-form-select-option
                    >
                  </b-form-select>
                </b-form-group>

                <b-form-group
                  id="selsub"
                  label=""
                  label-size="lg"
                  class="nested-form-group"
                  v-if="
                    testspace.structure == 'Subject' &&
                      testspace.test_institution != null
                  "
                >
                  <!-- <h5>Select Subject Combination (Maximum of {{ numberofSubjects }})</h5> -->
                  <span class="form-label"
                    >Please select the Subject(s) to be written in this Test
                    Space</span
                  >
                  <b-form-checkbox-group
                    id="selectsubject"
                    v-model="testspace.subjects"
                    :options="subjectsarr"
                    name="subjectspo"
                    stacked
                    :state="substate"
                  >
                    <b-form-invalid-feedback :state="substate"
                      >Please Select exactly {{ numberofSubjects }} subject(s)
                      to Proceed</b-form-invalid-feedback
                    >
                    <b-form-valid-feedback :state="substate"
                      >{{ testspace.subjects.length }} Subject(s) Selected
                      Successfully, Proceed.</b-form-valid-feedback
                    >
                  </b-form-checkbox-group>
                </b-form-group>

                <b-form-group
                  label="Select Testspace Module"
                  label-for="category"
                  v-if="
                    $route.query.module == 'base' ||
                      details.clearance_organization == 'Quicktest' ||
                      details.category != 'Organization'
                  "
                >
                  <b-form-select
                    id="module"
                    :options="modulearr"
                    v-model="testspace.module"
                    required
                  >
                    <b-form-select-option value="null"
                      >--Select Module--</b-form-select-option
                    >
                  </b-form-select>
                </b-form-group>


                <b-form-group v-if="
                  $route.query.module == 'base' ||
                      details.clearance_organization == 'Quicktest' ||
                      details.category != 'Organization'
                  "  label="" v-slot="{ ariaDescribedby }"
                >
                  <div class="tooltip-wrapper">
                    <p class="form-label">Test Mode</p>
                    <b-icon-info-circle-fill
                      id="tooltip-morelabels-3"
                      class="mt-2 cursor-pointer"
                    ></b-icon-info-circle-fill>
                    <b-tooltip
                      target="tooltip-morelabels-3"
                      custom-class="tooltip"
                      style="width: 500px"
                      triggers="hover"
                    >
                      <span class="info-span"
                        >*Test Mode is to set the Mode in which the test should
                        be taken. There are two options, Full or Limited.</span
                      ><br />
                      <span class="info-span"
                        >*When Test Mode is set to Limited, you are required to
                        choose the number</span
                      >
                    </b-tooltip>
                  </div>
                  <b-form-radio
                    v-model="testspace.space_mode"
                    :aria-describedby="ariaDescribedby"
                    name="mode"
                    value="full"
                    >Full</b-form-radio
                  >
                  <b-form-radio
                    v-model="testspace.space_mode"
                    :aria-describedby="ariaDescribedby"
                    name="mode"
                    value="limited"
                    >Limited</b-form-radio
                  >
                </b-form-group>

                <b-form-group
                  class="nested-form-group"
                  label=""
                  label-for="testmode"
                  v-if="testspace.space_mode == 'limited'"
                >
                  <div class="tooltip-wrapper">
                    <p class="form-label">
                      Number of questions for each subject in this test
                    </p>
                    <b-icon-info-circle-fill
                      id="tooltip-morelabels-4"
                      class="mt-2 cursor-pointer"
                    ></b-icon-info-circle-fill>
                    <b-tooltip
                      target="tooltip-morelabels-4"
                      custom-class="tooltip"
                      style="width: 500px"
                      triggers="hover"
                    >
                      <span class="info-span"
                        >*Set the amount of questions to limit test to.</span
                      ><br />
                      <span class="info-span"
                        >*This is in Per subject or Per Section Basis</span
                      >
                    </b-tooltip>
                  </div>
                  <b-form-spinbutton
                    id="modeque"
                    v-model="testspace.mode_limit_question"
                    min="0"
                    max="100"
                    step="1"
                  ></b-form-spinbutton>
                </b-form-group>

                <b-form-group v-if="testspace.space_mode == 'limited'" label="" label-for="totmark">
                  <div class="tooltip-wrapper">
                    <p class="form-label">Total Marks For this Tests</p>
                    <b-icon-info-circle-fill
                      id="tooltip-markalloted-1"
                      class="mt-1 cursor-pointer"
                    ></b-icon-info-circle-fill>
                    <b-tooltip
                      target="tooltip-markalloted-1"
                      custom-class="tooltip"
                      style="width: 500px"
                      triggers="hover"
                    >
                      <span class="info-span"
                        >*This the total Mark which the Whole test would be marked
                        against irrespective of the number of Subjects taken at a
                        sitting</span
                      ><br />
                      <span class="info-span"
                        >*It is very important in the Marking Process as it would be
                        used to determine the mark weight of each question</span
                      >
                      <span class="info-span"
                        >*Default Total Mark is 100</span
                      >
                    </b-tooltip>
                  </div>

                  <b-form-spinbutton
                    id="totmark"
                    v-model="testspace.mode_limit_totalmarks"
                    min="10"
                    max="500"
                    step="5"
                  ></b-form-spinbutton>
                </b-form-group>

                <b-form-group
                  class="nested-form-group"
                  label=""
                  label-for="testmode"
                  v-if="testspace.space_mode == 'limited'"
                >
                  <div class="tooltip-wrapper">
                    <p class="form-label">
                      Time in minutes for this test
                    </p>
                    <b-icon-info-circle-fill
                      id="tooltip-morelabels-5"
                      class="mt-2 cursor-pointer"
                    ></b-icon-info-circle-fill>
                    <b-tooltip
                      target="tooltip-morelabels-5"
                      custom-class="tooltip"
                      style="width: 500px"
                      triggers="hover"
                    >
                      <span class="info-span"
                        >*Set the amount of time in minutes to limit test
                        to.</span
                      ><br />
                      <span class="info-span">*This is for the whole test</span>
                    </b-tooltip>
                  </div>

                  <b-form-spinbutton
                    id="modeque"
                    v-model="testspace.mode_limit_time"
                    min="0"
                    max="100"
                    step="1"
                  ></b-form-spinbutton>
                </b-form-group>

                <b-form-group label="" label-for="takers">
                  <div
                    style="display: flex; justify-content: space-between"
                    class="form-label-wrapper"
                  >
                    <div class="tooltip-wrapper">
                      <p class="form-label">Test Candidates/Takers</p>

                      <b-icon-info-circle-fill
                        id="tooltip-morelabels-6"
                        class="mt-2 cursor-pointer"
                      ></b-icon-info-circle-fill>
                      <b-tooltip
                        target="tooltip-morelabels-6"
                        custom-class="tooltip"
                        style="width: 500px"
                        triggers="hover"
                      >
                        <span class="info-span"
                          >Input all the emails of the registered Users who are
                          allowed to take this Test</span
                        ><br />
                        <span class="info-span"
                          >Ensure each email is seperated by a Comma</span
                        >
                      </b-tooltip>
                    </div>
                    <div
                      @click="showImportCandidates = true"
                      style="
                        display: flex;
                        justify-content: flex-start;
                        cursor: pointer;
                        gap: 10px;
                        color: #243057;
                      "
                    >
                      <b-icon-files class="mt-1"></b-icon-files>
                      <p style="font-weight: bold">Import Candidates from Groups</p>
                    </div>
                  </div>
                  <b-form-tags
                    input-id="tags-separators"
                    v-model="testspace.takers"
                    separator=","
                    placeholder="Enter new emails or candidates IDs separated by Comma"
                    class="tag-input"
                    style="height: 100px"
                  ></b-form-tags>

                  {{ testspace.takers.length }} Takers
                </b-form-group>


                <b-sidebar
                  id="sidebar-1"
                  v-model="showImportCandidates"
                  width="400px"
                  title="Sidebar"
                  right
                  shadow
                >
                  <template #header>
                    <div style="display: flex; gap: 20px" class="mt-1">
                      <b-icon-x-circle
                        size="lg"
                        class="mt-1"
                        @click="showImportCandidates = false"
                        style="cursor: pointer"
                        color="#243057"
                      ></b-icon-x-circle>
                      <p>Import Candidates from Group</p>
                    </div>
                  </template>
                  <template #footer="{ hide }">
                    <div
                      class="d-flex py-3 text-light justify-content-end px-3 py-2"
                    >
                      <b-button size="lg" variant="primary" @click="hide"
                        >Close</b-button
                      >
                    </div>
                  </template>
                  <div class="px-3 py-2 mt-2">
                    <b-form-group
                      label="Select a Group"
                      label-for="group"
                      name="selectgroup2"
                    >
                      <b-form-select
                        id="group"
                        :options="groupsArray"
                        v-model="group_id"
                        @change="changeGroup"
                        aria-describedby="testgroups"
                        aria-controls="testgroups"
                        name="selectgroup"
                      >
                        <b-form-select-option value="null"
                          >--Select Group--</b-form-select-option
                        >
                      </b-form-select>
                    </b-form-group>

                    <div class="mt-5">
                      <div
                        style="display: flex; justify-content: space-between"
                      >
                        <p>View Candidates ({{ candidatesArray.length }})</p>
                        <b-form-checkbox
                          v-model="allSelected"
                          :indeterminate="indeterminate"
                          aria-describedby="flavours"
                          aria-controls="flavours"
                          @change="toggleAll"
                        >
                          {{ allSelected ? "Un-select All" : "Select All" }}
                        </b-form-checkbox>
                      </div>

                      <div class="candidates-card">
                        <div style="width: full">
                          <b-input-group class="mb-2 w-100">
                            <b-input-group-prepend is-text>
                              <b-icon icon="search"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input
                              type="search"
                              v-model="searchQuery"
                              @keyup="searchFilter"
                              @update="clearFilter"
                              @focus="searching = true"
                              placeholder="Search"
                            ></b-form-input>
                          </b-input-group>
                        </div>

                        <b-form-group
                          v-if="candidatesArray.length > 0"
                          label=""
                          v-slot="{ ariaDescribedby }"
                        >
                          <b-form-checkbox-group
                            v-model="testspace.takers"
                            size="md"
                            :options="candidatesArray"
                            :aria-describedby="ariaDescribedby"
                            name="flavour-2a"
                            stacked
                          ></b-form-checkbox-group>
                        </b-form-group>

                        <div
                          v-if="candidatesArray.length == 0 && !fetching2"
                          class="mt-3"
                        >
                          <p v-if="group_id.length != 0">
                            This Group Does not have any Candidates Yet
                          </p>
                          <p v-if="group_id.length == 0">
                            Select a Group to import From
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-sidebar>

                <b-form-group
                  class="nested-form-group"
                  label=""
                  label-for="testmode"
                >
                  <div class="tooltip-wrapper">
                    <p class="form-label">Test take Frequency</p>
                    <b-icon-info-circle-fill
                      id="tooltip-morelabels-2"
                      class="mt-2 cursor-pointer"
                    ></b-icon-info-circle-fill>
                    <b-tooltip
                      target="tooltip-morelabels-2"
                      custom-class="tooltip"
                      style="width: 500px"
                      triggers="hover"
                    >
                      <span class="info-span"
                        >*Test Frequency is the amount of times a User can take
                        the Test</span
                      ><br />
                      <span class="info-span"
                        >*If you want the users to take the test Unlimited
                        number of times, set the Test Frequency to Zero
                        (0)</span
                      >
                    </b-tooltip>
                  </div>

                  <b-form-spinbutton
                    id="modeque"
                    v-model="testspace.frequency"
                    min="0"
                    max="100"
                    step="1"
                  ></b-form-spinbutton>
                </b-form-group>

                <b-form-group
                  v-if="
                    $route.query.module == 'base' ||
                      details.clearance_organization == 'Quicktest' ||
                      details.category != 'Organization'
                  "
                  label=""
                  label-for="category"
                >
                  <div class="tooltip-wrapper">
                    <p class="form-label">Test Entry</p>
                    <b-icon-info-circle-fill
                      id="tooltip-morelabels-9"
                      class="mt-2 cursor-pointer"
                    ></b-icon-info-circle-fill>
                    <b-tooltip
                      target="tooltip-morelabels-9"
                      custom-class="tooltip"
                      style="width: 500px"
                      triggers="hover"
                    >
                      <span class="info-span"
                        >*Determine who can enter this testspace. Choose 'Any'
                        for the Public and 'Takers' for only those that has been
                        added to the Test takers field</span
                      ><br />
                    </b-tooltip>
                  </div>
                  <b-form-select
                    id="module"
                    :options="entryarr"
                    v-model="testspace.entry"
                    required
                  >
                    <b-form-select-option value="null"
                      >--Select Testspace Entry--</b-form-select-option
                    >
                  </b-form-select>
                </b-form-group>

                <b-form-group label="" v-slot="{ ariaDescribedby }">
                  <div class="tooltip-wrapper">
                    <p class="form-label">Use Test Wall</p>
                    <b-icon-info-circle-fill
                      id="tooltip-morelabels-7"
                      class="mt-2 cursor-pointer"
                    ></b-icon-info-circle-fill>
                    <b-tooltip
                      target="tooltip-morelabels-7"
                      custom-class="tooltip"
                      style="width: 500px"
                      triggers="hover"
                    >
                      <span class="info-span"
                        >*Test Wall prevents a User from taking the Test before
                        the Start Date and also Prevents a User from taking the
                        Test after the End Date</span
                      ><br />
                      <span class="info-span"
                        >*When Test Wall is used the Test Status is set to Close
                        automatically for dates outside the Wall</span
                      >
                    </b-tooltip>
                  </div>

                  <b-form-radio
                    v-model="testspace.wall"
                    :aria-describedby="ariaDescribedby"
                    name="wall"
                    value="Yes"
                    >Yes</b-form-radio
                  >
                  <b-form-radio
                    v-model="testspace.wall"
                    :aria-describedby="ariaDescribedby"
                    name="wall"
                    value="No"
                    >No</b-form-radio
                  >
                </b-form-group>

                <b-form-group>
                  <p class="form-label">Choose Test Start Date</p>
                  <b-form-datepicker
                    v-model="testspace.startdate"
                    :min="new Date()"
                    placeholder="Choose a Date"
                    required
                  ></b-form-datepicker>

                  <b-form-timepicker
                    v-model="testspace.starttime"
                    class="mt-2"
                    locale="en"
                  ></b-form-timepicker>
                </b-form-group>

                <b-form-group>
                  <p class="form-label">Choose Test End Date</p>

                  <b-form-datepicker
                    v-model="testspace.enddate"
                    :min="new Date()"
                    placeholder="Choose a Date"
                    required
                  ></b-form-datepicker>

                  <b-form-timepicker
                    v-model="testspace.endtime"
                    class="mt-2"
                    locale="en"
                  ></b-form-timepicker>
                </b-form-group>

                <b-form-group label="" v-slot="{ ariaDescribedby }">
                  <div class="tooltip-wrapper">
                    <p class="form-label">Test Status</p>
                    <b-icon-info-circle-fill
                      id="tooltip-morelabels-1"
                      class="mt-2 cursor-pointer"
                    ></b-icon-info-circle-fill>
                    <b-tooltip
                      target="tooltip-morelabels-1"
                      custom-class="tooltip"
                      style="width: 500px"
                      triggers="hover"
                    >
                      <span class="info-span"
                        >*Test Status sets the current status of the
                        testspace</span
                      ><br />
                      <span class="info-span"
                        >*When Test status is set to Close, The Test will not be
                        opened even if the scheduled time has reached and test
                        wall will not be considered</span
                      >
                    </b-tooltip>
                  </div>
                  <b-form-radio
                    v-model="testspace.status"
                    :aria-describedby="ariaDescribedby"
                    name="status"
                    value="Open"
                    >Open</b-form-radio
                  >
                  <b-form-radio
                    v-model="testspace.status"
                    :aria-describedby="ariaDescribedby"
                    name="status"
                    value="Closed"
                    >Closed</b-form-radio
                  >
                </b-form-group>

                <b-form-group label="" v-slot="{ ariaDescribedby }">
                  <div class="tooltip-wrapper">
                    <p class="form-label">Allow Takers View Solution</p>
                    <b-icon-info-circle-fill
                      id="tooltip-morelabels-8"
                      class="mt-2 cursor-pointer"
                    ></b-icon-info-circle-fill>
                    <b-tooltip
                      target="tooltip-morelabels-8"
                      custom-class="tooltip"
                      style="width: 500px"
                      triggers="hover"
                    >
                      <span class="info-span"
                        >*Prevent Takers from viewing solution after
                        submitting</span
                      ><br />
                    </b-tooltip>
                  </div>

                  <b-form-radio
                    v-model="testspace.viewSolution"
                    :aria-describedby="ariaDescribedby"
                    name="viewsolution"
                    value="Yes"
                    >Yes</b-form-radio
                  >
                  <b-form-radio
                    v-model="testspace.view_solution"
                    :aria-describedby="ariaDescribedby"
                    name="viewsolution"
                    value="No"
                    >No</b-form-radio
                  >
                </b-form-group>

                <b-form-group label="" v-slot="{ ariaDescribedby }">
                  <div class="tooltip-wrapper">
                    <p class="form-label">Allow takers view total score</p>
                    <b-icon-info-circle-fill
                      id="tooltip-morelabels-9"
                      class="mt-2 cursor-pointer"
                    ></b-icon-info-circle-fill>
                    <b-tooltip
                      target="tooltip-morelabels-9"
                      custom-class="tooltip"
                      style="width: 500px"
                      triggers="hover"
                    >
                      <span class="info-span"
                        >*Prevent takers from seeing their final score after
                        submitting</span
                      ><br />
                    </b-tooltip>
                  </div>

                  <b-form-radio
                    v-model="testspace.view_score"
                    :aria-describedby="ariaDescribedby"
                    name="viewscore"
                    value="Yes"
                    >Yes</b-form-radio
                  >
                  <b-form-radio
                    v-model="testspace.view_score"
                    :aria-describedby="ariaDescribedby"
                    name="viewscore"
                    value="No"
                    >No</b-form-radio
                  >
                </b-form-group>

                <div class="mt-3 mb-3">
                  <p class="form-label">Add Tags to this Testspace</p>
                  <div
                    class="row mt-2"
                    v-for="(tag, index) in tags"
                    :key="index"
                  >
                    <div class="col-lg-5">
                      <b-form-select
                        id="selectsbuject"
                        class="form-inp"
                        :options="tagsArray"
                        v-model="tag.name"
                        label="Select Tags"
                        required
                      >
                        <b-form-select-option value="null"
                          >--Select Tags--</b-form-select-option
                        >
                      </b-form-select>
                    </div>

                    <div class="col-lg-5">

                      <b-form-select
                        v-if="tag.name == 'Year'"
                        id="selectsbuject"
                        class="form-inp"
                        :options="yearArray"
                        v-model="tag.value"
                        label="Select Year"
                        required
                      >
                        <b-form-select-option value="null"
                          >--Select Year--</b-form-select-option
                        >
                      </b-form-select>
                      
                      <b-form-select
                        v-if="tag.name == 'Difficulty'"
                        id="selectsbuject"
                        class="form-inp"
                        :options="difficultyArray"
                        v-model="tag.value"
                        label="Select Difficulty"
                        required
                      >
                        <b-form-select-option value="null"
                          >--Select Difficulty--</b-form-select-option
                        >
                      </b-form-select>

                      <b-form-select
                        v-if="tag.name == 'Experience'"
                        id="selectsbuject"
                        class="form-inp"
                        :options="experienceArray"
                        v-model="tag.value"
                        label="Select Experience"
                        required
                      >
                        <b-form-select-option value="null"
                          >--Select Experience--</b-form-select-option
                        >
                      </b-form-select>
                    </div>
                    <div class="col-lg-1">
                      <b-icon-trash-fill
                        scale="1.5"
                        class="mt-2"
                        v-if="tags.length > index + 1"
                        @click="removeTag(index)"
                      ></b-icon-trash-fill>
                      <div class="flex gap-4">
                        <b-icon-plus-circle
                          class="mt-2"
                          scale="1.5"
                          v-if="tags.length == index + 1"
                          @click="addNewTag()"
                        ></b-icon-plus-circle>
                      </div>
                    </div>
                  </div>
                </div>

                <b-form-group label="Test description" label-for="description">
                  <b-form-textarea
                    rows="5"
                    id="description"
                    v-model="testspace.description"
                  >
                  </b-form-textarea>
                </b-form-group>

                <div
                  v-if="uploadstatus == 'added'"
                  class="alert alert-success p-3"
                >
                  Changes have been saved.
                </div>

                <div
                  v-if="uploadstatus == 'not-added'"
                  class="alert alert-danger p-3"
                >
                  {{ uploadmsg }}
                </div>

                <b-row>
                  <b-col></b-col>
                  <b-col md="6">
                    <b-form-group>
                      <b-overlay
                        :show="uploading"
                        rounded
                        opacity="0.6"
                        spinner-small
                        spinner-variant="primary"
                        class=""
                      >
                        <b-button
                          :disabled="empties"
                          type="submit"
                          class="btn-sub p-1 w-100"
                          variant="success"
                        >
                          {{
                            $route.params.trackid
                              ? "Save Changes"
                              : "Create Testspace"
                          }}
                        </b-button>
                      </b-overlay>
                      <b-button
                        v-if="uploading"
                        class="w-100 p-2 mt-3 btntxt"
                        variant="dark"
                        @click="stopproceed"
                      >
                        Cancel
                      </b-button>
                    </b-form-group>
                  </b-col>
                  <b-col> </b-col>
                </b-row>
              </b-form-group>
            </b-card>
          </b-overlay>
        </form>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import store from "@/store";

export default {
  data() {
    return {
      emptyin: this.empties,
      leaving: false,
      uploaded: false,
      uploading: false,
      config: "config",
      dismissCountDown: 60,
      subjectsarr: [],
      categoryarr: [],
      levelarr: [],
      coursesarr: [],
      sectionarr: [],
      modulearr: ["Test", "Competition", "Thirdparty"],
      entryarr: ["Any", "Takers"],
      scholarshiptypearr: [],
      institutionsarr: [],
      testspace: this.getForm(),
      sent: false,
      sameName: "No",
      mode: "Prototype",
      adding: false,
      getrawstring: "",
      org: "",
      uploadmsg: "",
      uploadstatus: "",
      tags: [
        {
          name: null,
          value: null
        }
      ],
      tagsArray: ["Difficulty", "Experience"],
      difficultyArray: ["Easy", "Medium", "Hard", "Very Difficult", "Expert"],
      experienceArray: [
        "Beginner",
        "Junior",
        "Mid-level",
        "Intermediate",
        "Senior",
        "Advanced",
        "Master"
      ],
      fetching: false,
      currenttestspace: {},
      groupsArray: [],
      group_id: "",
      candidatesArray: [],
      allSelected: false,
      indeterminate: false,
      fetching2: false,
      showImportCandidates: false,
      searchQuery: ""
    };
  },

  async mounted() {
    await store.dispatch("admin/fetchInstitutions");
    await store.dispatch("admin/fetchCategories");

    // let cklink = this.environ == 'development' ? "http://localhost/quicktest/plugins/ckeditor/ckeditor.js" : "https://quicktest.futavilla.com/js/ckeditor/ckeditor.js"
    // this.editorUrl = cklink

    this.setCurrentModule("Testspaces");

    this.getAllGroups();

    let org = this.details.clearance_organization;
    this.testspace.organization = org;

    // let inst = this.allinsti.map(x => x.name);

    if (
      this.$route.query.module == "base" ||
      this.details.clearance_organization == "Quicktest"
    ) {
      this.testspace.organization = this.details.clearance_organization;
      this.testspace.organization_id = this.details.clearance_organization_id;
    } else {
      this.testspace.organization = this.details.clearance_organization;
      this.testspace.organization_id = this.details.clearance_organization_id;
      this.testspace.category = "Thirdparty";
      this.testspace.module = "Test";
    }

    let inst = this?.allinsti
      ?.filter(
        x =>
          x.organization_trackid == this.details.clearance_organization_id &&
          x.organization_name == this.details.clearance_organization &&
          x.available == 'Yes'
      )
      .map(x => ({ text: x.name, value: x.track_id }));

    this.institutionsarray = inst;

    // let typesarray = this.Categories.filter((x) => x.organization_name == this.details.clearance_organization).map((x) => x.name);
    if (this.Categories.length > 0) {
      let typesarr = this.Categories.map(x => x.name);
      this.categoryarr = typesarr;
    }

    this.institutionsarr = inst;

    if (this.$route.params.trackid) {
      this.fetchData();
    }
  },
  // beforeRouteLeave(to, from, next) {
  //   this.$bvModal.show("modal-leave");

  //   if (this.leaving) {
  //     next();
  //   } else {
  //     next(false);
  //   }
  // },

  methods: {
    toggleAll(checked) {
      this.testspace.takers = checked
        ? this.candidatesArray.map(x => x.value)
        : [];
    },
    removeTag(index) {
      this.tags = this.tags?.splice(index, 1);
    },
    addNewTag() {
      this.tags.push({ name: null, value: null });
    },
    async fetchData() {
      this.fetching = true;
      try {
        const response = await this.fetchTestspace(this.$route.params.trackid);

        const testspace = response.data;
        this.currenttestspace = testspace;

        // this.subjectsarr = JSON.parse(testspace.test_subjects);
        let takersarray = JSON.parse(testspace.test_takers);
        this.getrawstring = JSON.parse(testspace.test_takers).toString();
        this.tags =
          testspace?.tags?.length > 0
            ? testspace.tags
            : [{ name: null, value: null }];
        // console.log(takersstring)
        this.testspace = {
          organization: this.details.clearance_organization,
          test_institution: testspace.test_institution,
          test_institution_id: testspace.test_institution_id,
          subjects: JSON.parse(testspace.test_subjects),
          category: testspace.test_category,
          structure: testspace.test_structure,
          level: testspace.test_level,
          tags: testspace.tags,
          course: testspace.test_course,
          description: testspace.test_description,
          frequency: Number(testspace.take_frequency),
          status: testspace.test_status,
          title: testspace.test_title,
          entry: testspace.test_entry,
          module: testspace.test_module,
          wall: testspace.test_wall,
          view_solution: testspace.view_solution,
          view_score: testspace.view_score,
          takers: takersarray,
          mode: testspace.test_mode,
          space_mode: testspace.space_mode,
          mode_limit_question: testspace.mode_limit_question,
          mode_limit_time: testspace.mode_limit_time,
          mode_limit_totalmarks: testspace.mode_limit_totalmarks,
          startdate: testspace.test_startdate,
          enddate: testspace.test_enddate,
          starttime: testspace.test_starttime,
          endtime: testspace.test_endtime,
          trackid: testspace.track_id,
          admin: this.$store.state.loginmaster.details.fullname,
          addedbytrackid: this.$store.state.loginmaster.details.trackid
        };

        if (
          this.$route.query.module == "base" ||
          this.details.clearance_organization == "Quicktest"
        ) {
          this.chgcategory();
          this.chgInstitution();
        } else {
          this.chgInstitution();
        }

        this.fetching = false;
      } catch (err) {
        console.log(err);
        this.fetching = false;
      }
    },

    chgcourses() {
      if (!this.$route.params.trackid) {
        this.testspace.course = null;
      }

      // Get the Whole Config Object of the selected Undergraduate Institution
      let institution = this.allinsti.find(
        x => x.track_id == this.testspace.test_institution_id
      );
      let levell = JSON.parse(institution.levels_config);
      // this.levelarray = levell.map(x => x.name);

      // Get the Chosen Level exact config Array
      let config = levell.find(x => x.name == this.testspace.level).config;
      // Now get the Courses from the courses Object of the Chosen level exact config Object
      let courses = config.find(x => x.name == "courses").values;

      // Inject this Array into the general courses Array for Selection
      this.coursesarr = courses;
    },

    chgsection() {
      if (!this.$route.params.trackid) {
        this.testspace.section = null;
      }

      // Get the Whole Config Object of the selected Undergraduate Institution
      let levell = this.allinsti
        .filter(
          x =>
            x.category == this.testspace.category &&
            x.name == this.testspace.test_institution
        )
        .map(x => x.levels_config);

      let reallevell = JSON.parse(levell);

      // Get the Chosen Level exact config Array
      let config = reallevell
        .filter(x => x.name == this.testspace.level)
        .map(x => x.config);
      // Now get the Courses from the courses Object of the Chosen level exact config Object
      let sections = config[0]
        .filter(x => x.name == "sectionsperc")
        .map(x => x.values);

      let courseindex = this.coursesarr.indexOf(this.testspace.course);
      let nsections = sections[0][courseindex];
      let sectarr = Array();

      for (let i = 0; i < nsections; i++) {
        let alpha = Array(
          "A",
          "B",
          "C",
          "D",
          "E",
          "F",
          "G",
          "H",
          "I",
          "J",
          "K"
        );
        sectarr.push("Section " + alpha[i]);
      }

      this.sectionarr = sectarr;
    },

    leaveRoute() {
      this.leaving = true;
      this.$bvToast.toast("Press the Back Button again to Exit", {
        noCloseButton: true,
        solid: true,
        variant: "dark",
        toaster: "b-toaster-bottom-center"
      });
    },
    stayRoute() {
      this.$bvToast.toast("Exiting Canceled", {
        noCloseButton: true,
        solid: true,
        variant: "dark",
        toaster: "b-toaster-bottom-center"
      });
    },

    async setTestspace() {
      this.setloader();

      this.testspace.tags = this.tags;

      if (this.$route.params.trackid) {
        await this.updateTestspace(this.testspace).then(response => {
          this.uploading = false;
          this.uploadstatus = response.data.result;
          this.uploadmsg = response.data.message;

          if (
            this.$route.query.module == "base" ||
            this.details.clearance_organization == "Quicktest"
          ) {
            this.leaving = true;
            this.$router.push({ name: "listtestspaces" });
          } else {
            this.leaving = true;
            this.$router.push({ name: "listtestspacesorg" });
          }
        });
      } else {
        await this.createTestspace(this.testspace).then(response => {
          this.testspace.test_institution = null;
          this.testspace.category = null;
          this.testspace.subjects = [];
          this.testspace.level = null;
          this.testspace.course = null;
          this.testspace.section = null;
          this.testspace.frequency = 1;
          this.testspace.status = null;
          this.testspace.title = "";
          this.testspace.wall = null;
          this.testspace.startdate = "";
          this.testspace.enddate = "";
          this.uploaded = true;
          this.uploading = false;
          this.uploadstatus = response.data.result;
          this.uploadmsg = response.data.message;
        });

        if (
          this.$route.query.module == "base" ||
          this.details.clearance_organization == "Quicktest"
        ) {
          this.leaving = true;
          this.$router.push({ name: "listtestspaces" });
        } else {
          this.leaving = true;
          this.$router.push({ name: "listtestspacesorg" });
        }
      }
    },
    getForm() {
      return {
        organization: "",
        organization_id: "",
        test_institution: null,
        test_institutionsn: "",
        test_institution_id: "",
        subjects: [],
        category: null,
        structure: "",
        level: null,
        course: null,
        entry: "Takers",
        tags: null,
        module: null,
        description: "",
        frequency: 1,
        status: "Open",
        title: "",
        wall: "Yes",
        view_solution: "No",
        view_score: "No",
        takers: [],
        startdate: "",
        enddate: "",
        starttime: "",
        endtime: "",
        space_mode: "limited",
        mode_limit_question: 10,
        mode_limit_time: 30,
        mode_limit_totalmarks: 100,
        mode: "Prototype",
        admin: this.$store.state.loginmaster.details.fullname,
        addedbytrackid: this.$store.state.loginmaster.details.trackid
      };
    },
    chgInstitution() {
      let institution = this.allinsti.find(
        x => x.track_id == this.testspace.test_institution_id
      );

      this.testspace.test_institutionsn = institution.short_name;
      this.testspace.test_institution = institution.name;
      this.testspace.structure = institution.structure;
      this.subjectsarr = [];
      this.levelarr = [];

      if (this.testspace.structure == "Section") {
        let levell = institution.levels_config;
        //console.log(JSON.parse(levell))
        let reallevell = JSON.parse(levell);

        this.levelarr = reallevell.map(x => x.name);
      } else {
        let subbb = this.allinsti.find(
          x => x.track_id == this.testspace.test_institution_id
        )?.subjects_offered;
        this.subjectsarr = JSON.parse(subbb);
      }

      if (this.$route.params.trackid) {
        this.chgcourses();
      } else {
        this.testspace.subjects = [];
      }
    },
    chgcategory() {
      // this.testspace.test_institution = null;
      this.org = this.details.clearance_organization;

      let inst = this?.allinsti
        ?.filter(
          x =>
            x.organization_trackid == this.details.clearance_organization_id &&
            x.organization_name == this.details.clearance_organization
        )
        .map(x => ({ text: x.name, value: x.track_id }));
      this.institutionsarr = inst;

      this.testspace.organization = this.org;
      let tabi = this.Categories.filter(
        x => x.name == this.testspace.category
      ).map(x => x.structure);
      this.testspace.structure = tabi[0];

      let sameName = this.Categories.filter(
        x => x.name == this.testspace.category
      ).map(x => x.sameName);
      this.sameName = sameName[0];

      if (this.sameName == "Yes") {
        this.testspace.test_institution = this.testspace.category;

        console.log(this.allinsti)
        console.log(this.testspace.category)

        let institution = this.allinsti.find(
          x => x.name == this.testspace.category
        );

        console.log(institution);

        this.subjectsarr = JSON.parse(institution?.subjects_offered);

        this.structure = institution.structure;
        this.testspace.structure = institution.structure;

        this.testspace.test_institution_id = institution.track_id;
        this.testspace.test_institutionsn = institution.short_name;
      }
    },
    addtoArray() {
      let rawstring = this.getrawstring;
      // console.log(rawstring);
      let strarray = "";
      if (rawstring.length > 0) {
        strarray = rawstring.split(",");
      }
      // console.log(strarray)
      this.testspace.takers = strarray;
    },

    setloader() {
      this.uploading = true;
    },
    changeGroup() {
      // this.testspace.takers = [];
      this.getAllCandidates();
    },

    async getAllGroups() {
      try {
        const response = await this.fetchAllGroups();
        this.groupsArray = response.data.map(x => ({
          text: x.name,
          value: x.track_id
        }));
      } catch (err) {
        console.log(err);
        this.fetching = false;
      }
    },
    async getAllCandidates() {
      this.fetching2 = true;
      try {
        const response = await this.fetchAllCandidates(this.group_id);
        this.candidatesArray = response.data.map(x => ({
          text: x.first_name + " " + x.last_name,
          value: x.email ? x.email : x.candidate_id
        }));

        this.fetching2 = false;
      } catch (err) {
        console.log(err);
        this.fetching2 = false;
      }
    },

    clearField() {
      this.searchQuery = "";
      this.closeSearch();
    },

    async clearFilter(event) {
      if (event?.length == 0) {
        this.setQuery(`page=${1}&perPage=${10}`);
        this.getAllCandidates();
      }
    },

    async searchFilter() {
      //   let query = this.searchQuery;

      try {
        if (this.searchQuery.length == 0) {
          this.clearField();
          this.setQuery(`page=${1}&perPage=${10}`);
          this.getAllCandidates();
          this.searching = false;
        } else {
          this.setQuery(`search=${this.searchQuery}`);
          this.getAllCandidates();
          this.searching = false;
        }
      } catch (err) {
        console.log(err);
      }
    },
    closeSearch() {
      this.searching = false;
      this.searchQuery = "";
    },

    copylink() {
      var cop = document.getElementById("copier");
      cop.select();
      cop.setSelectionRange(0, 99999);
      document.execCommand("copy");
    },
    copynow() {
      document.execCommand("copy");
    },
    stopproceed() {
      this.uploading = false; // If user clicks the cancel button, stops the spinner and enables the proceed button.
    },

    ...mapActions("admin", [
      "chekquestion",
      "createTestspace",
      "updateTestspace",
      "fetchTestspace",
      "setCurrentModule",
      "fetchAllGroups",
      "fetchAllCandidates",
      "setQuery"
    ])
  },

  watch: {
    "testspace.takers"(newValue) {
      console.log(newValue);
      const array = [...new Set(this.candidatesArray.map(x => x.value))];
      if (newValue.length === 0) {
        this.indeterminate = false;
        this.allSelected = false;
      } else if (newValue.length === array.length) {
        this.indeterminate = false;
        this.allSelected = true;
      } else {
        this.indeterminate = true;
        this.allSelected = false;
      }
    }
  },

  computed: {
    ...mapState({
      details: state => state.loginmaster.details,
      loggedin: state => state.loginmaster.loggedIn,
      likequestions: state => state.admin.likequestions,
      allinsti: state => state.admin.allinstitutions.data,
      fileimage: state => state.admin.qimageurl,
      environ: state => state.loginmaster.environ,
      Categories: state => state.admin.Categories,
      listtestspaces: state => state.admin.listtestspaces
    }),
    leav() {
      return this.leaving;
    },
    empties() {
      if (
        this.testspace.organization.length <= 0 ||
        this.testspace.test_institution == null ||
        (this.testspace?.structure == "Subject" &&
          this.testspace.subjects.length <= 0) ||
        (this.testspace?.structure == "Section" &&
          this.testspace.level == null) ||
        this.testspace.category == null ||
        this.testspace?.structure.length <= 0 ||
        this.testspace.status == null ||
        this.testspace.title.length <= 0 ||
        this.testspace.startdate.length <= 0 ||
        this.testspace.enddate <= 0 ||
        !this.substate
      ) {
        return true;
      } else {
        return false;
      }
    },
    substate() {
      if (this.testspace.structure != "Section") {
        // Checks if the number of subjects picked is the same as the number of Subjects required for this exam and if all fields has been selected
        return this.testspace.subjects.length != 0
          ? // this.allinsti
            //   .filter(
            //     x =>
            //       x.name == this.testspace.test_institution &&
            //       x.category == this.testspace.category
            //   )
            //   .map(x => x.num_courses)[0]
            true
          : (false && this.testspace.test_institution == null) ||
              this.proceeding;
      } else {
        // Checks if all required fields has been selected
        return (
          (this.testspace.level != null && this.testspace.course != null) ||
          this.proceeding
        );
      }
    },

    numberofSubjects() {
      //returns the number of subjects required for the selected institution
      return 1;
      // this.allinsti
      //   .filter(x => x.name == this.testspace.test_institution)
      //   .map(x => x.num_courses)[0];
    },
    yearArray(){
      const currentYear = new Date();
      const yearArray = []

      for(let i= 1990; i <= currentYear.getFullYear(); i++){
        yearArray.push(i)
      }

      return yearArray;
    }
  }
};
</script>

<style scoped>
.base-select {
  padding: 10px;
}

.btn-sub {
  font-size: 18px;
  font-weight: bold;
  background-color: #00984a;
  color: white;
  cursor: pointer;
}

.edicon {
  height: 150px;
}
.tag-input {
  overflow: auto;
  scrollbar-width: thin;
  max-height: 400px;
}

.copyinline {
  background-color: #000000;
  color: white;
  display: inline-flex;
  overflow: scroll;
}

.copyicon {
  width: 20%;
  cursor: pointer;
}

.copytext {
  width: 80%;
  overflow-y: scroll;
}

.copier {
  position: absolute;
  left: -9999px;
}
.active-method {
  background-color: rgb(8, 8, 238);
}

.inactive-method {
  background-color: rgba(128, 128, 136, 0.74);
}
.txtformat {
  font-size: 14px;
  line-height: 10px;
  white-space: nowrap;
}
.txtcode {
  overflow: auto;
}
.sqheader {
  font-size: 1.2rem;
  background-color: rgb(240, 231, 231);
  border-radius: 10px 10px;
  display: flex;
  font-weight: bold;
}
.heasub {
  width: 70%;
}

.sqicon {
  width: 30%;
  text-align: right;
  cursor: pointer;
}

.tooltip-wrapper {
  display: flex;
  flex: row wrap;
  gap: 10px;
}

.level-wrapper {
  padding: 13px 20px;
  background: rgb(246, 244, 244);
  border: 1px solid black;
  border-radius: 10px 10px;
}

.head-wrapper {
  display: flex;
  flex: row wrap;
  gap: 10px;
  justify-content: space-between;
  background: rgb(246, 244, 244);
}

.info-span {
  display: block;
  text-align: left;
  color: white;
}

.form-label {
  font-weight: semi-bold;
  font-size: 20px;
}

.candidates-card {
  border: 1px solid black;
  border-radius: 10px 10px;
  padding: 20px;
  min-height: 100px;
  max-height: 100vh;
  overflow-y: auto;
}

@media screen and (max-width: 768px) {
  .image-attachment {
    width: 100%;
    height: 200px;
  }
}

@media screen and (min-width: 768px) {
  .image-attachment {
    width: 100%;
    height: 300px;
  }
}
</style>
